import script from "./MenuMobileItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobileItem.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobileItem.vue?vue&type=style&index=0&id=0d238c35&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d238c35"]])

export default __exports__